import { supabase } from '../supabaseClient';

export const PortalCredentialsService = {
    async listCredentials(clientId) {
        if (!clientId) return { data: [], error: new Error('Missing client id') };
        try {
            const { data, error } = await supabase
                .from('client_credentials')
                .select('*')
                .eq('client_id', clientId)
                .order('created_at', { ascending: false });

            if (error) throw error;
            return { data: data || [], error: null };
        } catch (error) {
            console.error('[PortalCredentialsService] listCredentials failed', error);
            return { data: [], error };
        }
    },

    async getCredential(id) {
        if (!id) return { data: null, error: new Error('Missing id') };
        try {
            const { data, error } = await supabase
                .from('client_credentials')
                .select('*')
                .eq('id', id)
                .single();

            if (error) throw error;
            return { data, error: null };
        } catch (error) {
            console.error('[PortalCredentialsService] getCredential failed', error);
            return { data: null, error };
        }
    }
};
